module.exports = __webpack_public_path__ + "static/media/logo.a851f9d4.svg";